import type { TranslationKey } from "./en";

export const fi: Record<TranslationKey, string> = {
  appName: "Rikskurs",
  tagline: "Ruotsin keskuspankin korot ja valuuttakurssit",
  "nav.language": "Kieli",
  "nav.theme": "Vaihda teema",
  "category.currency": "Valuutta",
  "category.interest": "Korko",
  "category.index": "Indeksi",
  "picker.series": "Valitse sarja",
  "picker.from": "Alkaen",
  "picker.to": "Asti",
  "picker.apply": "Näytä",
  "chart.value": "Arvo",
  "chart.date": "Päivämäärä",
  "table.date": "Päivämäärä",
  "table.value": "Arvo",
  "table.change": "Muutos",
  "unit.sekPerUnit": "SEK / {currency}",
  "unit.percent": "Prosenttia",
  "unit.indexPoints": "Indeksipistettä",
  "state.loading": "Ladataan tietoja…",
  "state.empty": "Tälle ajanjaksolle ei vielä ole tietoja. Riksbank julkaisee uudet luvut yleensä seuraavana pankkipäivänä.",
  "state.error": "Yhteys Riksbankin tietopalveluun epäonnistui. Yritä hetken kuluttua uudelleen.",
  "state.retry": "Yritä uudelleen",
  "footer.source": "Tiedot: Ruotsin keskuspankin (Riksbank) rajapinta",
  "series.repoRate": "Ohjauskorko",
  "series.depositRate": "Talletuskorko",
  "series.lendingRate": "Antolainauskorko",
  "series.fineTuningRate": "Hienosäätökorko",
  "series.referenceRate": "Viitekorko",
  "series.stiborTN": "STIBOR Tomorrow/Next",
  "series.kixIndex": "KIX (kruunuindeksi)",
  "series.tcwIndex": "TCW-indeksi",
  "readout.latest": "Viimeisin arvo",
  "readout.asOf": "Tilanne {date}",
  "readout.noData": "Ei arvoa tälle ajanjaksolle",
  "table.noChange": "Ei edellistä pistettä",
  "table.empty": "Ei näytettäviä rivejä.",
  "errorBoundary.title": "Jokin meni pieleen",
  "errorBoundary.message": "Tapahtui odottamaton virhe. Lataa sivu uudelleen jatkaaksesi.",
  "errorBoundary.reload": "Lataa uudelleen",
};
